import { Flex, Typography } from '@banhala/ui-kit';
import React from 'react';

type Props = {
  updatedAt: string;
};

export const PopularKeywordHeader = ({ updatedAt }: Props) => {
  return (
    <Flex.Row
      justifyContent="space-between"
      alignItems="center"
      padding={{ horizontal: 16 }}
      height={44}
    >
      {/* 제목이 가용 너비를 점유하도록 flex={1} (Fabric에서 flex 없는 Text가 너비 과소할당되어
          공간이 남아도 말줄임되는 것 방지). numberOfLines={1}은 큰 글꼴 시 개행 방지용 (ENABLE-1109) */}
      <Flex flex={1}>
        <Typography type="subtitle1" numberOfLines={1}>
          인기 검색어
        </Typography>
      </Flex>
      <Typography type="body2" color="content_secondary" numberOfLines={1}>
        {updatedAt}
      </Typography>
    </Flex.Row>
  );
};
